import React, { useState, useRef, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import PhoneInput, { isValidPhoneNumber, getCountryCallingCode, parsePhoneNumber } from "react-phone-number-input";
import service from "../../service/apiService";
import { httpConstants } from "../../lib/constants";
import tenantService from "../../service/tenant";
import { validateEmail } from "../../utilities/utillFunction";
import { Divider } from "primereact/divider";
import { Toast } from "primereact/toast";
import "primeflex/primeflex.css";
import { useHistory } from "react-router-dom";

export default function ProfileEdit() {
    const accept = ".jpg, .jpeg, .png";
    const resendOTPTimer = 60; // in seconds
    const serviceId = localStorage.getItem("serviceId");
    const [showEditDialog, setShowEditDialog] = useState(false);
    const [editField, setEditField] = useState("");
    const [newName, setNewName] = useState("");
    const [newEmail, setNewEmail] = useState("");
    const [newMobile, setNewMobile] = useState("");
    const [profileImg, setProfileImg] = useState(localStorage.getItem("profileImg"));
    const [otpSent, setOtpSent] = useState(false);
    const [otpVerified, setOtpVerified] = useState(false);
    const [otp, setOtp] = useState("");
    const [sendingOtp, setSendingOtp] = useState(false);
    const [verificationInProgress, setVerificationInProgress] = useState(false);
    const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [otpTimer, setOtpTimer] = useState(resendOTPTimer);
    const [resendEnabled, setResendEnabled] = useState(false);
    const [showPostUpdateDialog, setShowPostUpdateDialog] = useState(false);

    const [userName, setUserName] = useState(localStorage.getItem("username"));
    const [emailId, setEmailId] = useState(localStorage.getItem("emailId"));
    const [mobile, setMobile] = useState(localStorage.getItem("email"));
    const [currentUser, setCurrentUser] = useState(null);

    const toast = useRef();
    const intervalRef = useRef(null);

    const history = useHistory();

    const serviceData = JSON.parse(localStorage.getItem("service"));
    const fieldMap = {
        name: "Name",
        email: "Email",
        mobile: "Mobile Number",
    };
    const defcountryCode = {
        india: "IN",
        mexico: "MX",
        canada: "CA",
        usa: "US",
    };
    let defCode = serviceData.location && serviceData.location.operatingCountry ? defcountryCode[serviceData.location.operatingCountry] : serviceData.customer && serviceData.customer.region ? serviceData.customer.region.toUpperCase() : "IN";

    useEffect(() => {
        getUserDetails();
    }, []);
    function getUserDetails() {
        const nqPayload = { filter: { "user.email": emailId, serviceId: serviceId, "user.role": "ihdesigner", $or: [{ "user.disabledUser": { $exists: false } }, { "user.disabledUser": false }] } };
        service
            .httpDBService(nqPayload, "imaginehome_master_db", "nq-userpermissions")
            .then((res) => {
                if (res) {
                    const userObj = res[0];
                    setCurrentUser(userObj);
                    setUserName(userObj.user.name);
                    setEmailId(userObj.user.email);
                    setMobile(userObj.user.mobile);
                    setProfileImg(userObj.image);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    const changeProfilePic = (e) => {
        let file = e.target.files[0];
        let url = process.env.REACT_APP_TENANT_SERVICE_URL + "/update-profile-pic";

        const formData = new FormData();
        formData.append("serviceId", serviceId);
        formData.append("email", emailId);
        formData.append("image", file);
        service.httpService(httpConstants.METHOD_TYPE.POST, formData, url, { "Content-Type": httpConstants.CONTENT_TYPE.MULTIPART_FORM_DATA }).then((res) => {
            if (res && res.success === true) {
                setProfileImg(res.responseData);
                localStorage.setItem("profileImg", res.responseData);
                document.getElementById("profile-pic").src = process.env.REACT_APP_IMAGE_STATIC_URL + "/" + encodeURIComponent(res.responseData);
                toast.current?.show({
                    severity: "success",
                    summary: "Success",
                    detail: `Profile image updated successfully.`,
                });
            }
        });
    };

    const openDialog = (field) => {
        setEditField(field);
        setShowEditDialog(true);
    };
    const navigateToHome = () => {
        history.replace("/ih-user");
    };
    const validateMobile = (mob) => {
        if (mob.length > 6 && mob.length < 16) return true;
        else return false;
    };
    const validateInput = () => {
        if (editField === "name" && !newName) return "Please enter the name";
        if (editField === "email" && (!newEmail || !validateEmail(newEmail))) return "Please enter the valid email";
        if (editField === "mobile" && (!newMobile || !validateMobile(newMobile))) return "Please enter the valid mobile number";
        return null;
    };

    const updateValue = (e) => {
        e.target.blur();
        let invalidMsg = validateInput();
        if (!invalidMsg) {
            updateDesigner();
        } else {
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: invalidMsg,
            });
        }
    };

    const onDismissed = () => {
        setShowEditDialog(false);
        setShowConfirmationDialog(false);
        setOtpSent(false);
        setOtpVerified(false);
        setOtp("");
        setNewEmail("");
        setNewMobile("");
        setNewName("");
        setUpdating(false);
        setResendEnabled(false);
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
        }
        setOtpTimer(resendOTPTimer);
    };
    const startResendTimer = () => {
        setOtp("");
        setOtpVerified(false);
        setResendEnabled(false);
        setOtpTimer(resendOTPTimer);

        // Clear any existing interval before starting a new one
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
        }

        intervalRef.current = setInterval(() => {
            setOtpTimer((prev) => {
                if (prev <= 1) {
                    clearInterval(intervalRef.current);
                    setResendEnabled(true);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    const sendTheOtp = (e) => {
        let invalidMsg = validateInput();
        if (invalidMsg) {
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: invalidMsg,
            });
            return;
        }
        setSendingOtp(true);
        // Replace with real send logic
        const newValue = editField === "email" ? newEmail : newMobile;
        const oldValue = editField === "email" ? emailId : mobile;
        if (!oldValue || !newValue) return;
        const payLoad = { oldValue, newValue, type: editField };
        tenantService
            .sendOTPtoUser(payLoad)
            .then((res) => {
                setSendingOtp(false);
                if (res) {
                    if (res.responseCode === 200) {
                        toast.current?.show({
                            severity: "success",
                            summary: "Success",
                            detail: res.message || `OTP sent successfully.`,
                        });
                        setOtpSent(true);
                        startResendTimer();
                    } else {
                        startResendTimer();
                        toast.current?.show({
                            severity: "error",
                            summary: "Error",
                            detail: res?.message || `Some error occurred. Please try again later.`,
                        });
                    }
                } else {
                    startResendTimer();
                    toast.current?.show({
                        severity: "error",
                        summary: "Error",
                        detail: res?.message || `Some error occurred. Please try again later.`,
                    });
                }
            })
            .catch((e) => {
                setSendingOtp(false);
                startResendTimer();
                toast.current?.show({
                    severity: "error",
                    summary: "Error",
                    detail: e?.response?.data?.message || e?.message || `Some error occurred. Please try again later.`,
                });
                console.error(e);
            });
    };
    const verifyOtp = (e) => {
        setVerificationInProgress(true);

        const newValue = editField === "email" ? newEmail : newMobile;
        const payLoad = { newValue, otp, type: editField };

        tenantService
            .verifyOTP(payLoad)
            .then((res) => {
                setVerificationInProgress(false);
                if (res) {
                    if (res.responseCode === 200) {
                        toast.current?.show({
                            severity: "success",
                            summary: "Success",
                            detail: res.message || "OTP verfied successfully.",
                        });
                        setOtpVerified(true);
                        setShowConfirmationDialog(true);
                    } else {
                        toast.current?.show({
                            severity: "error",
                            summary: "Error",
                            detail: res.message || "Some error occurred. Please try again.",
                        });
                    }
                } else {
                    toast.current?.show({
                        severity: "error",
                        summary: "Error",
                        detail: res.message || "Some error occurred. Please try again.",
                    });
                }
            })
            .catch((e) => {
                setVerificationInProgress(false);
                toast.current?.show({
                    severity: "error",
                    summary: "Error",
                    detail: e?.response?.data?.message || e?.message || `Some error occurred. Please try again later.`,
                });
                console.error(e);
            });
    };
    const updateDesigner = async () => {
        setUpdating(true);
        const newValue = editField === "name" ? newName : editField === "email" ? newEmail : newMobile;

        let formData = new FormData();
        formData.append("serviceId", serviceId);
        formData.append("userId", currentUser.user.userId);
        formData.append(editField, newValue);

        let countryCode;
        if (editField === "mobile") {
            let mobileCountry = parsePhoneNumber(newMobile);
            if (mobileCountry) {
                countryCode = getCountryCallingCode(mobileCountry.country);
            }
            formData.append("countryCode", "+" + countryCode);
        }
        tenantService
            .updateUserDetails(formData)
            .then(async (res) => {
                setUpdating(false);
                if (res) {
                    if (res.responseCode === 200) {
                        localStorage.setItem(editField === "name" ? "username" : editField === "email" ? "emailId" : "email", newValue);

                        if (editField === "email" || editField === "mobile") {
                            // create/update QR Code 
                            const result = await tenantService.createQRCode({ email: editField === "email" ? newValue : localStorage.getItem("emailId"), mobile: editField === "mobile" ? newValue : localStorage.getItem("email"), createNew: true });
                            if (!result || result.responseCode !== 200) {
                                console.log(`QR code generation/updation failed`);
                            }
                            setShowEditDialog(false);
                            setShowPostUpdateDialog(true);
                            setTimeout(() => {
                                setShowPostUpdateDialog(false);
                                navigateToHome();
                            }, 5000); // show transfer message for 5 seconds
                        } else {
                            // for name update
                            getUserDetails();
                            onDismissed();
                            toast.current?.show({
                                severity: "success",
                                summary: "Success",
                                detail: `Name updated successfully.`,
                            });
                        }
                    } else {
                        toast.current?.show({
                            severity: "error",
                            summary: "Error",
                            detail: res.message || `Some error occurred. Please try again later.`,
                        });
                    }
                } else {
                    toast.current?.show({
                        severity: "error",
                        summary: "Error",
                        detail: res.message || `Some error occurred. Please try again later.`,
                    });
                }
            })
            .catch((e) => {
                setUpdating(false);
                toast.current?.show({
                    severity: "error",
                    summary: "Error",
                    detail: e?.response?.data?.message || e?.message || `Some error occurred. Please try again later.`,
                });
                console.error(e);
            });
    };
    const renderEditDialog = () => {
        const oldValue = editField === "name" ? userName : editField === "email" ? emailId : mobile;
        const newValue = editField === "name" ? newName : editField === "email" ? newEmail : newMobile;
        const isOtpField = editField === "email" || editField === "mobile";

        return (
            <Dialog
                style={{
                    width: "30vw",
                    maxWidth: "35rem",
                    fontFamily: "Gerstner-ProgramRegular",
                }}
                breakpoints={{ "960px": "75vw", "640px": "95vw" }}
                header={<h3 className="m-0 font-light font-larken">{`Edit ${fieldMap[editField]}`}</h3>}
                visible={showEditDialog}
                onHide={onDismissed}
            >
                <div className="flex flex-column gap-3 mt-3">
                    {!showConfirmationDialog && (
                        <>
                            <div className="flex flex-column mb-3">
                                <label className="mb-1">Old {fieldMap[editField]}</label>
                                {editField === "mobile" ? (
                                    <PhoneInput disabled placeholder="Enter phone number" style={{ height: "3rem" }} className="p-inputtext p-component p-filled w-full phone-input--disabled addFeatureInput" value={mobile} international defaultCountry={defCode} />
                                ) : (
                                    <InputText value={oldValue} disabled className="w-full addFeatureInput" style={{ height: "3rem" }} />
                                )}
                            </div>
                            <div className="flex flex-column mb-3">
                                <label className="mb-1">New {fieldMap[editField]}</label>
                                {editField === "mobile" ? (
                                    <PhoneInput
                                        placeholder="Enter phone number"
                                        style={{ height: "3rem" }}
                                        className="p-inputtext p-component p-filled w-full addFeatureInput"
                                        value={newMobile}
                                        onChange={setNewMobile}
                                        international
                                        defaultCountry={defCode}
                                        error={newMobile ? (isValidPhoneNumber(newMobile) ? undefined : "Invalid phone number") : "Phone number required"}
                                    />
                                ) : editField === "email" ? (
                                    <InputText type="email" value={newEmail} onChange={(e) => setNewEmail(e.target.value)} className="w-full addFeatureInput" style={{ height: "3rem" }} />
                                ) : (
                                    <InputText type="text" value={newName} onChange={(e) => setNewName(e.target.value)} className="w-full addFeatureInput" style={{ height: "3rem" }} />
                                )}
                            </div>
                            {/* OTP Section */}
                            {isOtpField && !otpSent && (
                                <div className="flex justify-content-center">
                                    <Button
                                        label={sendingOtp ? "Sending the OTP..." : "Send OTP"}
                                        onClick={sendTheOtp}
                                        className="font-Gerstner-ProgramRegular mt-2 w-full p-button-rounded p-button-sm text-sm charcoal-color"
                                        style={{ letterSpacing: "1.44px", backgroundColor: "#9AAB89" }}
                                        disabled={sendingOtp || (editField === "email" && !newEmail) || (editField === "mobile" && !newMobile)}
                                    />
                                </div>
                            )}
                            {otpSent && !otpVerified && (
                                <>
                                    <div className="flex flex-column mb-3">
                                        <label className="mb-1">Enter OTP</label>
                                        <InputText value={otp} onChange={(e) => setOtp(e.target.value)} maxLength={6} placeholder="Enter OTP" className="w-full addFeatureInput" style={{ height: "3rem" }} />
                                    </div>
                                    <div className="flex flex-row" style={{ gap: "1rem" }}>
                                        <Button
                                            label={verificationInProgress ? "Verifying..." : "Verify OTP"}
                                            className="font-Gerstner-ProgramRegular p-button-rounded charcoal-color w-full"
                                            style={{ letterSpacing: "1.44px", backgroundColor: "#9AAB89" }}
                                            disabled={!otp || verificationInProgress}
                                            onClick={verifyOtp}
                                        />
                                        <Button
                                            label={resendEnabled ? "Resend OTP" : `Resend in ${otpTimer < 10 ? `0${otpTimer}` : otpTimer}s`}
                                            className="font-Gerstner-ProgramRegular p-button-rounded p-button-outlined charcoal-color w-full"
                                            style={{ letterSpacing: "1.44px" }}
                                            onClick={sendTheOtp}
                                            disabled={!resendEnabled || sendingOtp}
                                        />
                                    </div>
                                </>
                            )}
                            {/* Name field updates immediately */}
                            {!isOtpField && <Button onClick={updateValue} label={updating ? "Updating..." : "Update"} disabled={updating} className="font-Gerstner-ProgramRegular p-button-rounded charcoal-color" style={{ letterSpacing: "1.44px", backgroundColor: "#9AAB89" }} />}
                        </>
                    )}
                    {/* Confirmation buttons for OTP-verified fields */}
                    {showConfirmationDialog && (
                        <>
                            <div className="flex align-items-center justify-content-center">
                                <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: "2rem", color: "#f0ad4e" }} />
                                <span style={{ lineHeight: "1.5" }}>
                                    Are you sure you want to update your {fieldMap[editField].toLowerCase()} from <b>{oldValue}</b> to <b>{newValue}</b>?<br />
                                    Once confirmed, all your data will be transferred to <b>{newValue}</b>.
                                </span>
                            </div>

                            <div className="grid w-full gap-3 mt-3">
                                <div className="col-12 md:col-6">
                                    <Button
                                        label="No"
                                        className="font-Gerstner-ProgramRegular p-button-rounded p-button-outlined charcoal-color w-full"
                                        onClick={onDismissed}
                                        style={{
                                            letterSpacing: "1.44px",
                                        }}
                                    />
                                </div>
                                <div className="col-12 md:col-6">
                                    <Button
                                        disabled={updating}
                                        label={updating ? "Updating..." : "Yes"}
                                        className="font-Gerstner-ProgramRegular p-button-rounded charcoal-color w-full"
                                        style={{
                                            letterSpacing: "1.44px",
                                            backgroundColor: "#9AAB89",
                                        }}
                                        onClick={updateValue}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </Dialog>
        );
    };

    const renderPostUpdateDialog = () => {
        return (
            <Dialog
                style={{
                    width: "28vw",
                    maxWidth: "35rem",
                    fontFamily: "Gerstner-ProgramRegular",
                }}
                breakpoints={{ "960px": "75vw", "640px": "95vw" }}
                header={<h3 className="m-0 font-light font-larken">Update Complete</h3>}
                visible={showPostUpdateDialog}
                modal
                closable={false}
                draggable={false}
                dismissableMask={false}
            >
                <div className="flex flex-column align-items-center justify-content-center text-center py-3">
                    <i className="p-button-icon pi pi-check-circle text-green-500" style={{ fontSize: "2rem", marginBottom: "1rem" }} aria-hidden="true"></i>
                    <p className="text-lg m-0">Your transfer is in progress. This may take a few moments.</p>
                </div>
            </Dialog>
        );
    };
    const renderEditButton = (val) => {
        return <Button onClick={() => openDialog(val)} icon="pi pi-pencil" style={{ height: "1.8rem", width: "1.8rem", padding: "1rem" }} className="font-Gerstner-ProgramRegular cursor-pointer sage-ivory p-button-rounded m-0 p-button-icon-only" />;
    };
    return (
        <div className="p-4 shadow-2 border-round surface-card w-full max-w-xl mx-auto">
            <Toast ref={toast} />
            <div
                className="flex align-items-center"
                onClick={() => {
                    navigateToHome();
                }}
                style={{ gap: 10, fontFamily: "Larken" }}
            >
                <img src="/images/Back.svg" className="cursor-pointer" />
                <h2 className="m-0 font-light">Edit Profile</h2>
            </div>
            <Divider style={{ backgroundColor: "#9AAB89", height: "1px" }} />
            <div className="flex align-items-center mb-4" style={{ gap: "1rem" }}>
                <div className="relative" style={{ width: "6rem", height: "6rem" }}>
                    <img
                        id="profile-pic"
                        src={process.env.REACT_APP_IMAGE_STATIC_URL + "/" + encodeURIComponent(profileImg)}
                        onError={(e) => (e.target.src = process.env.REACT_APP_IMAGE_STATIC_URL + "/images/dummy.jpg")}
                        alt="Profile"
                        style={{
                            width: "100%",
                            height: "100%",
                            borderRadius: "50%",
                            objectFit: "cover",
                            border: "1px solid #BFAD5B",
                        }}
                    />
                    <div className="fileUpload changeProfileImg">
                        <div className="text-6xl">
                            <Button icon="pi pi-camera" className="sage-ivory p-button-rounded p-1 m-0 font-Gerstner-ProgramRegular" />
                        </div>
                        <input style={{ width: "50%", top: "22%", right: "5%" }} type="file" className="upload mt-2 h-2rem w-2rem cursor-pointer" value="" onChange={changeProfilePic} accept={accept} />
                    </div>
                </div>
                <h2 className="font-Gerstner-ProgramRegular charcoal-color">{userName}</h2>
            </div>

            <div className="flex align-items-center justify-content-between py-3 border-bottom-1 surface-border" style={{ borderBottomColor: "#9AAB89" }}>
                <div className="flex flex-column">
                    <label className="text-sm text-600 mb-1">Name</label>
                    <span className="text-lg">{userName}</span>
                </div>
                {renderEditButton("name")}
            </div>

            <div className="flex align-items-center justify-content-between py-3 border-bottom-1 surface-border" style={{ borderBottomColor: "#9AAB89" }}>
                <div className="flex flex-column">
                    <label className="text-sm text-600 mb-1">Email</label>
                    <span className="text-lg">{emailId}</span>
                </div>
                {renderEditButton("email")}
            </div>

            <div className="flex align-items-center justify-content-between py-3 " style={{ borderBottomColor: "#9AAB89" }}>
                <div className="flex flex-column w-full pr-3">
                    <label className="text-sm text-600 mb-1">Mobile</label>
                    <PhoneInput disabled placeholder="Enter phone number" className="p-inputtext p-component p-filled w-full phone-input--disabled" value={mobile} international defaultCountry={defCode} />
                </div>
                {renderEditButton("mobile")}
            </div>

            {showEditDialog && renderEditDialog()}
            {showPostUpdateDialog && renderPostUpdateDialog()}
        </div>
    );
}
